import React, { useCallback, useMemo, useState } from "react";
import type { IncrementView, SequenceView } from "@services/drybulkCargoOperationsApi";
import { ExecutionContext, type ActiveExecution, type ExecutionKind } from "./executionContext";

export const ExecutionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [active, setActive] = useState<ActiveExecution | null>(null);
  const open = useCallback(
    (kind: ExecutionKind, sequence: SequenceView, increment?: IncrementView) =>
      setActive({ kind, sequence, increment }),
    [],
  );
  const close = useCallback(() => setActive(null), []);
  const value = useMemo(() => ({ active, open, close }), [active, open, close]);
  return <ExecutionContext.Provider value={value}>{children}</ExecutionContext.Provider>;
};

export default ExecutionProvider;
